import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { I18n } from '@fiverr-private/i18n-react';
import { Heading, Text } from '@fiverr-private/typography';
import { useModalContext } from '@fiverr-private/overlay';
import { Button } from '@fiverr-private/button';
import { SendModalStepProps } from './types';

const TRANSLATION_PREFIX = 'legal_documents_package.send_modal.success_step';

export const SuccessStep = ({ sellerName }: SendModalStepProps) => {
    const { close } = useModalContext();
    return (
        <Stack maxWidth="455px" alignItems="center" direction="column" margin="auto">
            <Heading size="h_lg">
                <I18n k={`${TRANSLATION_PREFIX}.title`} />
            </Heading>
            <Text size="b_md" color="bodySecondary" textAlign="center">
                <I18n k={`${TRANSLATION_PREFIX}.description`} params={{ name: sellerName }} />
            </Text>
            <Button onClick={close} marginTop="8">
                <I18n k={`${TRANSLATION_PREFIX}.submit`} />
            </Button>
        </Stack>
    );
};
